import { previewFrame } from "@innoclouds/db";
import { type Decoration, isPreviewMessage, isRecord, PREVIEW_NS, type PreviewMessage } from "@innoclouds/ui";
import { shallowRef } from "vue";
import { applyFont, highlight } from "./appearance";
import { installMockBackend, installPreviewBackend, receivePreviewBackend } from "./backend";
import { capture } from "./capture";
import { describe } from "./describe";
import { corsForSnapshotImages, warmImages } from "./images";
import { listenInspectToggle, setInspect } from "./inspect";
import { isMockMode, postToPreview, previewParentCandidate, previewParentOrigin, previewTile } from "./mode";
import { navigate } from "./navigate";
import { showUntrustedNotice } from "./notice";
import { isolateMockStorage, isolateStorage, releaseStaleDatabases } from "./storage";
import { focusTile } from "./tiles";

export { isMockMode, isPreviewMode } from "./mode";

export const previewDecoration = shallowRef<Decoration | null | undefined>(undefined);

const KEEP_AWAKE = 5000;

const handleParentMessage = (message: PreviewMessage) => {
	if (message.type === "response" || message.type === "socket-data") receivePreviewBackend(message);
	if (message.type === "decoration" && (message.decoration === null || isRecord(message.decoration))) previewDecoration.value = message.decoration;
	if (message.type === "highlight")
		highlight(typeof message.screen === "string" ? message.screen : null, typeof message.element === "string" ? message.element : null);
	if (message.type === "inspect") setInspect(message.enabled === true);
	if (message.type === "focus" && previewTile) void focusTile(message);
	if (message.type === "font" && (message.font === null || isRecord(message.font))) void applyFont(message.font);
	if (message.type === "warm") warmImages(message.urls);
	if (message.type === "describe") postToPreview(describe(message.id));
	if (message.type === "capture") void capture(message.id).then(postToPreview);
	if (message.type === "navigate" && !previewTile) void navigate(message).then(postToPreview);
};

const connectToParent = (origin: string) => {
	window.addEventListener("message", (event) => {
		if (event.source === window.parent && event.origin === origin && isPreviewMessage(event.data)) handleParentMessage(event.data);
	});
	if (!previewTile) listenInspectToggle();
	postToPreview({ ns: PREVIEW_NS, type: "ready" });
};

if (previewFrame) {
	isolateStorage(previewFrame);
	installPreviewBackend();
	void releaseStaleDatabases().catch(() => {});
	window.setInterval(() => document.dispatchEvent(new MouseEvent("mousemove", { bubbles: true })), KEEP_AWAKE);

	if (previewParentOrigin) {
		corsForSnapshotImages();
		connectToParent(previewParentOrigin);
	} else showUntrustedNotice(previewParentCandidate);
}

// DEV прямо здесь — чтобы условие свернулось при сборке и @innoclouds/mock не попал в прод-бандл
if (import.meta.env.DEV && isMockMode) {
	isolateMockStorage();
	installMockBackend();
	console.info("[mock] VITE_MOCK_API=true — точка, меню, дизайн и decoration с бэкенда, остальное отвечает @innoclouds/mock");
}
